var app = angular.module('leonardo');

function getTsSdk() {
  return window.tsembed || window.tsEmbed || window.TsEmbedSDK || null;
}

var ThoughtSpotService = function($q, $window, $log, $http, ConfigThemeService) {
  var initialized = false;
  var cachedExperience = null;
  var cachedLiveboardId = null;
  var tokenRequestInFlight = null;
  var currentEmbed = null;

  var web_url = ConfigThemeService.config.url_config.web_url;


  function requestTrustedToken() {
    if (tokenRequestInFlight) return tokenRequestInFlight;

    var jwt = localStorage.getItem('jwt_token');
    if (!jwt) {
      $log.error('[ThoughtSpotService] JWT not found; cannot request trusted token');
      return $q.reject(new Error('JWT missing'));
    }
    var url = window.LEO_BASE_URL + '/api/2.0/reporting/auth/'

    tokenRequestInFlight = $http({
      method: 'GET',
      url,
      headers: { 'Authorization': 'jwt ' + jwt }
    })
      .then(function(res) {
    var data = res.data;
    if (!data.token) return $q.reject(new Error('Token missing'));
    cachedExperience = (data.experience ? String(data.experience).toLowerCase() : null);
    if (data.liveboard_id) {
      cachedLiveboardId = data.liveboard_id;
    } else {
      cachedLiveboardId = null;  // ← RESET if no ID
    }
    return data.token;
    }, function(err) {
      $log.error('[ThoughtSpotService] Failed to fetch trusted token', err);
      return $q.reject(err);
    }).finally(function() {
      tokenRequestInFlight = null;
    });

    return tokenRequestInFlight;
  }

  function ensureInit() {
    if (initialized) return;
    var sdk = getTsSdk();
    if (!sdk) {
      $log.error('[ThoughtSpotService] Visual Embed SDK not found on window.');
      return;
    }

    sdk.init({
      thoughtSpotHost: window.TS_HOST,
      authType: sdk.AuthType.TrustedAuthTokenCookieless,
      getAuthToken: requestTrustedToken,
      customizations: {
        iconSpriteUrl: web_url + '/img/ts-icons.svg',
        content: {
          strings: {
            "Spotter": "LeoIQ",
            "Ask Spotter": "Ask LeoIQ",
          }
        },
        style: {
          customCSS: {
            variables: { '--ts-var-nav-background': '#36475f' },
            rules_UNSTABLE: {
              '.classic-nav-module__homeLink, [data-testid="home-link"], .classic-nav-module__tsLogo, .ts-header-logo, .footer-module__footerText , .footer-module__footerLogo ,.layout-module__rightPanel ,.home-container-module__homepageCarouselContainer': {
                display: 'none !important',
                visibility: 'hidden !important',
                width: '0 !important',
                height: '0 !important'
              },
              '[data-testid="classic-nav-item-Data"], [data-testid="classic-nav-item-Monitor"],[data-testid="classic-nav-item-Admin"]': {
                display: 'none !important'
              }
            }
          }
        }
      }
    });
    initialized = true;  
  }

function renderFullApp(el) {
  ensureInit();
  var sdk = getTsSdk();
  if (!sdk) return;

  if (currentEmbed) try { currentEmbed.destroy(); } catch(e) {}

  var liveboardIdToOpen = cachedLiveboardId;

  if (!liveboardIdToOpen) {
    var appEmbed = new sdk.AppEmbed(el, {
      thoughtSpotHost: window.TS_HOST,
      showPrimaryNavbar: true,
      disableProfileAndHelp: true,
      hideOrgSwitcher: true,
      isLiveboardCompactHeaderEnabled: true,
      isLiveboardMasterpiecesEnabled: true,
      hideIrrelevantChipsInLiveboardTabs: true,
      layout: { displayStyle: "HEADER" },
      frameParams: { width: "100%", height: "100vh" }
    });

    appEmbed.render();
    currentEmbed = appEmbed;

    return {
      instance: appEmbed,
      destroy: () => { try { appEmbed.destroy(); } catch(e) {} }
    };
  }

  var appEmbed = new sdk.AppEmbed(el, {
    thoughtSpotHost: window.TS_HOST,
    showPrimaryNavbar: true,
    disableProfileAndHelp: true,
    hideOrgSwitcher: true,
    pageId: sdk.Page.Liveboard,
    isLiveboardCompactHeaderEnabled: true,
    isLiveboardMasterpiecesEnabled: true,
    hideIrrelevantChipsInLiveboardTabs: true,
    path: `/pinboard/${liveboardIdToOpen}`,  
    layout: { displayStyle: "HEADER" },
    frameParams: { width: "100%", height: "100vh" }
  });

  appEmbed.render();
  currentEmbed = appEmbed;

  return {
    instance: appEmbed,
    destroy: () => { try { appEmbed.destroy(); } catch(e) {} }
  };
}

  function renderLiveboard(el, opts) {
    ensureInit();
    var sdk = getTsSdk();
    if (!sdk) return;

    const visibleActions = [
      sdk.Action.Download, sdk.Action.DownloadAsCsv, sdk.Action.DownloadAsXlsx,
      sdk.Action.DownloadAsPdf, sdk.Action.DownloadAsPng, sdk.Action.Present,
      sdk.Action.ShowUnderlyingData, sdk.Action.PersonalisedViewsDropdown,
      sdk.Action.CrossFilter, sdk.Action.RemoveCrossFilter,
      sdk.Action.AxisMenuFilter, sdk.Action.AxisMenuRemove,
      sdk.Action.AxisMenuSort, sdk.Action.AxisMenuTextWrapping
    ];

    if (currentEmbed) try { currentEmbed.destroy(); } catch(e) {}

    function createAndRender(liveboardId) {
      var embed = new sdk.LiveboardEmbed(el, {
        liveboardId, isLiveboardCompactHeaderEnabled: true,
        isLiveboardMasterpiecesEnabled: true,
        hideIrrelevantChipsInLiveboardTabs: true,
        vizId: opts && opts.vizId,
        frameParams: (opts && opts.params) || { width: '100%', height: '100%' },
        visibleActions
      });
      currentEmbed = embed;
      return {
        instance: embed,
        whenRendered: embed.render(),
        destroy: () => { try { embed.destroy(); } catch(e) {} }
      };
    }

    if (cachedLiveboardId) {
      return createAndRender(cachedLiveboardId);
    }

    var deferred = $q.defer();
    var embedInstance = null;

    requestTrustedToken()
      .then(() => {
        try {
          var out = createAndRender(cachedLiveboardId);
          embedInstance = out.instance;
          out.whenRendered
            .then(res => deferred.resolve(res))
            .catch(err => deferred.reject(err));
        } catch (e) {
          deferred.reject(e);
        }
      })
      .catch(err => {
        deferred.reject(err);
      });

    return {
      instance: null,
      whenRendered: deferred.promise,
      destroy: () => { if (embedInstance) try { embedInstance.destroy(); } catch(e) {} }
    };
  }
function renderSmart(el, opts) {
  ensureInit();

  if (opts && opts.fullApp === true) {
    return renderFullApp(el);
  }
  if (cachedExperience === 'app') {
    return renderFullApp(el);
  }

  if (cachedExperience === 'liveboard' && cachedLiveboardId) {
    return renderLiveboard(el, opts);
  }

  var deferred = $q.defer();
  var embedRef = { instance: null };

  requestTrustedToken()
    .then(function() {
      try {
        if (opts && opts.fullApp === true) {
          var forcedApp = renderFullApp(el);
          embedRef.instance = forcedApp.instance;
          return $q.resolve();
        }

        if (cachedExperience === 'app') {
          var outApp = renderFullApp(el);
          embedRef.instance = outApp.instance;
          return $q.resolve();
        }

        if (cachedExperience === 'liveboard' && cachedLiveboardId) {
          var outLive = renderLiveboard(el, opts);
          embedRef.instance = outLive.instance;
          return outLive.whenRendered || $q.resolve();
        }

        var outApp2 = renderFullApp(el);
        embedRef.instance = outApp2.instance;
        return $q.resolve();

      } catch (e) {
        return $q.reject(e);
      }
    })
    .then(function(res) {
      deferred.resolve(res);
    })
    .catch(function(err) {
      deferred.reject(err);
    });

  return {
    instance: null,
    whenRendered: deferred.promise,
    destroy: function() {
      if (embedRef.instance) { try { embedRef.instance.destroy(); } catch(e) {} }
    }
  };
}


  function logoutTs() {
    var sdk = getTsSdk();
    if (sdk && sdk.logout) sdk.logout();
  }
  return {
    init: ensureInit,
    renderLiveboard: renderLiveboard,
    renderFullApp: renderFullApp,
    renderSmart: renderSmart,
    logout: logoutTs
  };
};

app.service('ThoughtSpotService', ['$q', '$window', '$log', '$http', 'ConfigThemeService', ThoughtSpotService]);
